import React from 'react';
import { Activity } from 'lucide-react';

const ACTIVITY_LEVELS = [
  { id: 'sedentary', label: 'Sedentary', desc: 'Desk job, minimal exercise', multiplier: 1.2 },
  { id: 'light', label: 'Lightly Active', desc: 'Light exercise 1-3 days/week', multiplier: 1.375 },
  { id: 'moderate', label: 'Moderately Active', desc: 'Exercise 3-5 days/week', multiplier: 1.55 },
  { id: 'very_active', label: 'Very Active', desc: 'Hard exercise 6-7 days/week', multiplier: 1.725 },
  { id: 'extreme', label: 'Athlete', desc: 'Training 2x/day or very physical job', multiplier: 1.9 },
];

export { ACTIVITY_LEVELS };

export const ActivityStep = ({ formData, setFormData, calculateTargets }) => (
  <div className="space-y-3 max-w-md mx-auto">
    {ACTIVITY_LEVELS.map(a => (
      <button
        key={a.id}
        data-testid={`activity-${a.id}`}
        onClick={() => {
          const updated = { ...formData, activity_level: a.id };
          setFormData(calculateTargets(updated));
        }}
        className={`w-full p-5 rounded-2xl text-left transition-all border-2 flex items-center gap-4 ${
          formData.activity_level === a.id
            ? 'border-[#1A3A4A] dark:border-[#6B9E8A] bg-[#1A3A4A]/5 dark:bg-[#6B9E8A]/10'
            : 'border-transparent bg-white/80 dark:bg-[#141C22]/80 hover:border-[#1A3A4A]/20'
        } shadow-sm`}
      >
        <Activity className={`w-6 h-6 flex-shrink-0 ${formData.activity_level === a.id ? 'text-[#1A3A4A] dark:text-[#6B9E8A]' : 'text-[#7A7A72]'}`} />
        <div>
          <h3 className="font-semibold text-[#1A3A4A] dark:text-[#F0EDE8]">{a.label}</h3>
          <p className="text-sm text-[#7A7A72] dark:text-[#A1A1AA]">{a.desc}</p>
        </div>
      </button>
    ))}
    {formData.activity_level && formData.tdee > 0 && (
      <div className="mt-4 p-4 rounded-2xl bg-[#1A3A4A]/5 dark:bg-[#6B9E8A]/5 border border-[#1A3A4A]/10 dark:border-[#6B9E8A]/10" data-testid="tdee-display">
        <p className="text-sm text-[#7A7A72] dark:text-[#A1A1AA] mb-1">Your body burns approximately</p>
        <p className="text-2xl font-bold text-[#1A3A4A] dark:text-[#F0EDE8]">{formData.tdee} cal/day</p>
        <p className="text-xs text-[#7A7A72] mt-1">
          {formData.goal === 'lose_weight' && `Your target: ${formData.calories_target} cal/day (${formData.tdee - formData.calories_target} cal deficit)`}
          {formData.goal === 'gain_muscle' && `Your target: ${formData.calories_target} cal/day (+${formData.calories_target - formData.tdee} cal surplus)`}
          {formData.goal === 'maintain' && `Your target: ${formData.calories_target} cal/day (maintenance)`}
          {formData.goal === 'improve_nutrition' && 'Focus on food quality \u2014 no calorie target'}
        </p>
      </div>
    )}
  </div>
);
